import React, { useState, useContext, useEffect, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { SITEKEY } from "../../context/constValues";
import { loginConfirmedAction } from "../../store/actions/AuthActions";
import Swal from "sweetalert2";
import Turnstile from "react-turnstile";
import BgImage from "../../images/bg.png";
import pol from "../../images/pol.jpg";
import { loginAdmin } from "../../api/AdminApi";
import AuthContext from "../../context/auth-context";

function Login() {
  const history = useHistory();
  const [rememberMe, setRememberMe] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState(null);
  const authCtx = useContext(AuthContext);
  const dispatch = useDispatch();
  const turnstileRef = useRef();

  

  // Carga datos guardados si "Remember Me" estaba activo
  useEffect(() => {
    const storedEmail = localStorage.getItem("rememberEmail");
    const storedPassword = localStorage.getItem("rememberPassword");
    if (storedEmail) {
      setEmail(storedEmail);
      setPassword(storedPassword || "");
      setRememberMe(true);
    }
  }, []);

  // Limpia campos si se desmarca "Remember Me"
  const handleRememberChange = (checked) => {
    setRememberMe(checked);
    if (!checked) {
      setEmail("");
      setPassword("");
      localStorage.removeItem("rememberEmail");
      localStorage.removeItem("rememberPassword");
    }
  };

  const onLogin = async (e) => {
    e.preventDefault();

    if (!isVerified || !turnstileToken) {
      Swal.fire({ title: "Error", text: "Por favor completa la verificación de seguridad", icon: "error", confirmButtonText: "Aceptar" });
      return;
    }

    Swal.fire({ title: "Ingresando", didOpen: () => Swal.showLoading() });

    try {
      const response = await loginAdmin({ usuario: email, password });
      if (response.token) {
        const expiration = new Date(Date.now() + 50 * 60 * 1000).toISOString();
        authCtx.login(response.token, expiration, rememberMe);

        if (rememberMe) {
          localStorage.setItem("rememberEmail", email);
          localStorage.setItem("rememberPassword", password);
        }

        dispatch(loginConfirmedAction({ idToken: response.token }));
        history.push("/sesiones");
        Swal.close();
      }
    } catch (error) {
      const errorMessage = error.message || "Error en el inicio de sesión. Por favor intenta de nuevo.";
      // Mostrar error sin deshabilitar el botón de ingresar
      Swal.fire({ title: "Error", text: errorMessage, icon: "error", confirmButtonText: "Aceptar" });
      // No resetear isVerified ni turnstileToken para mantener el botón habilitado
    }
  };

  return (
    <div className="container h-100">
      <div className="row h-100 align-items-center justify-contain-center">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <div className="row m-0">
                <div
                  className="col-xl-6 col-md-6 sign text-center sign-bg d-flex align-items-center justify-content-center"
                  style={{ backgroundImage: `url(${pol})` }}
                >
                  <img
                    src={BgImage}
                    alt="Empresa"
                    style={{ width: 300, display: 'block', margin: 'auto' }}
                  />
                </div>
                <div className="col-xl-6 col-md-6">
                  <div className="sign-in-your px-2">
                    <h4 className="fs-20">Ingrese con su Cuenta</h4>
                    <span>Bienvenido! loguea con los datos proporcionados</span>
                    <form onSubmit={onLogin}>
                      <div className="mb-3">
                        <label className="mb-1"><strong>Cuenta</strong></label>
                        <input
                          required
                          type="text"
                          className="form-control"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Tu cuenta"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="mb-1"><strong>Contraseña</strong></label>
                        <input
                          required
                          type="password"
                          className="form-control"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="Tu contraseña"
                        />
                      </div>
                      <div className="row d-flex justify-content-between mt-4 mb-2">
                        <div className="form-check custom-checkbox ms-1">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="remember_checkbox"
                            checked={rememberMe}
                            onChange={(e) => handleRememberChange(e.target.checked)}
                          />
                          <label className="form-check-label" htmlFor="remember_checkbox">
                            Recuerdame
                          </label>
                        </div>
                      </div>
                      <div className="text-center mb-2">
                        <button
                          type="submit"
                          className="btn btn-primary btn-block"
                          disabled={!isVerified}
                        >
                          Ingresar
                        </button>
                      </div>
                     { <Turnstile
                        ref={turnstileRef}
                        theme="light"
                        sitekey={SITEKEY}
                        onVerify={(token) => { setTurnstileToken(token); setIsVerified(true); }}
                        onError={() => { setIsVerified(false); setTurnstileToken(null); }}
                        onExpire={() => { setIsVerified(false); setTurnstileToken(null); }}
                      /> }
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  errorMessage: state.auth.errorMessage,
  successMessage: state.auth.successMessage,
  showLoading: state.auth.showLoading
});

export default connect(mapStateToProps)(Login);
